import React from 'react';
import ReactDOM from 'react-dom/client';
import "scss/commonStyle.scss";
import './index.css';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import store from "./app/store";
import ScrollToTop from "utilities/ScrollToTop";
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "antd/dist/antd.min.css";
import "rsuite/dist/rsuite.min.css"
//import "assets/css/global.css";
//import "assets/css/ant.css";
//import "assets/scss/css/commonStyle.css";



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <Provider store={store}>
    <ScrollToTop>
      <App />
    </ScrollToTop>
  </Provider>

);
reportWebVitals();
